import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { url } from 'statics';
import { ErrorResponse, PaymentGateways } from 'types';

const usePaymentGateways = ({
  queries,
  enabled,
}: {
  queries: { pay_currency: string };
  enabled: boolean;
}): UseQueryResult<PaymentGateways[], ErrorResponse> => {
  let queryParams = '?';
  const entries = Object.entries(queries);
  if (entries.length > 0) {
    entries.forEach(([key, value], i) => {
      queryParams += `${key}=${value}${i === entries.length - 1 ? '' : '&'}`;
    });
  }

  return useQuery([`${url.paymentGateways}${queryParams}`], { enabled });
};
export default usePaymentGateways;
